import { graphql } from '@/lib/graphql';

export const NewVoicemailCountSubscription = graphql(`
  subscription NewVoicemailCount($organizationId: Uuid!) {
    voicemailsAggregate(where: { organizationId: { _eq: $organizationId }, status: { _eq: "new" } }) {
      aggregate {
        count
      }
    }
  }
`);

export const UnreviewedCallErrorCountSubscription = graphql(`
  subscription UnreviewedCallErrorCount($organizationId: Uuid!) {
    callErrorsAggregate(where: { organizationId: { _eq: $organizationId }, reviewedAt: { _isNull: true } }) {
      aggregate {
        count
      }
    }
  }
`);
